import React from 'react';
import {
  FDBodyText,
  FDLabelText,
  FDPaper,
  FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';

const labelProps = {
  size: 'md',
  color: 'textDisabled',
};

const infoColProps = {
  direction: 'column',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  flex: 1,
};

const TransferCompleteStatusCard = ({
  amount,
  transferDate,
  transferStatus,
  transferSourceMaskedAccountNumber,
}) => {
  const d = new Date(transferDate);
  const date = `${d.getMonth() + 1}/${d.getDate()}/${d.getYear()}`;

  return (
    <FDPaper
      rounded
      padding={3}
      spacing={2}
      color="subtle"
      appearance="flat"
    >
      <FDStack direction="column" spacing={1.5}>
        <FDStack direction="row" alignItems="flex-start" flex={1} spacing={3}>
          {amount && (
          <FDStack {...infoColProps}>
            <FDLabelText {...labelProps} value="Amount" />
            <FDBodyText size="md" value={amount} />
          </FDStack>
          )}
          {transferDate && (
          <FDStack {...infoColProps} flex={1.5}>
            <FDLabelText {...labelProps} value="Date" />
            <FDBodyText size="md" value={date} />
          </FDStack>
          )}
        </FDStack>
        <FDStack direction="row" alignItems="flex-start" flex={1} spacing={3}>
          {transferSourceMaskedAccountNumber && (
            <FDStack {...infoColProps}>
              <FDLabelText {...labelProps} value="Transfer Source" />
              <FDBodyText size="md" value={transferSourceMaskedAccountNumber} />
            </FDStack>
          )}
          {transferStatus && (
            <FDStack {...infoColProps} flex={1.5}>
              <FDLabelText {...labelProps} value="Status" />
              <FDBodyText size="md" value={transferStatus} />
            </FDStack>
          )}
        </FDStack>
      </FDStack>
    </FDPaper>
  );
};

TransferCompleteStatusCard.propTypes = {
  amount: PropTypes.string,
  transferDate: PropTypes.string,
  transferStatus: PropTypes.string,
  transferSourceMaskedAccountNumber: PropTypes.string,
};

export { TransferCompleteStatusCard };
